import Axios from "axios";
import {
    SET_PRODUCTION_TEMPLETE_LIST,
    UNSET_PRODUCTION_TEMPLETE_LIST,
} from "@/store/mutation-types";
import { 
    productionTempleteResource,
} from "@/store/api";

const state = {
    getTemplateList: [],
};

const getters = {
    getTemplateList(state) {
        return state.getTemplateList;
    },
};

const mutations = {
    [SET_PRODUCTION_TEMPLETE_LIST](state, data) {
        state.getTemplateList = data;
    },
    [UNSET_PRODUCTION_TEMPLETE_LIST](state) {
        state.getTemplateList = [];
    },
};

const actions = {
    saveTemplate({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(productionTempleteResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateTemplate({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${productionTempleteResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getTemplateList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(productionTempleteResource)
            .then(function (response) {
            commit('SET_PRODUCTION_TEMPLETE_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRODUCTION_TEMPLETE_LIST');
            reject(error);
            });
        });
    },

    getTemplateById({ commit }, data) {
        const getTemplateRecordById = `${productionTempleteResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getTemplateRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

